export const LIVE_ALERT_EVENT_TYPE_OPTIONS: ReadonlyArray<{
  label: string;
  value: string;
}> = [
  // The API exact-matches `eventType`; keep this list to emitted safe values.
  { label: "Financial sync failed", value: "Financial sync failed" },
  { label: "First sync stopped", value: "First sync stopped" },
  { label: "Sign-up connection failed", value: "Sign-up connection failed" },
  { label: "Support Enquiry", value: "Support enquiry" },
  {
    label: "Subscription access",
    value: "subscription_required_support_request",
  },
  { label: "Gmail alert delivery", value: "Gmail alert delivery" },
  { label: "Billing webhook failure", value: "Billing webhook failure" },
  { label: "Billing failure", value: "Billing failure" },
  { label: "Billing dispute", value: "Billing dispute" },
  { label: "Code review needs attention", value: "Codex pull request review" },
  { label: "Pipeline needs attention", value: "Pipeline failure" },
  { label: "Bug board needs review", value: "Monday bug board exception" },
  {
    label: "Support request needs review",
    value: "Monday support request exception",
  },
  {
    label: "Improvement request needs review",
    value: "Monday improvement exception",
  },
  {
    label: "Onboarding item needs review",
    value: "Monday onboarding exception",
  },
  {
    label: "Cancellation item needs review",
    value: "Monday cancellation exception",
  },
  {
    label: "Monday alerts need reconnecting",
    value: "Monday live-alert source unavailable",
  },
  {
    label: "Forms submission review",
    value: "forms.submission.review_required",
  },
  {
    label: "Forms contact review",
    value: "forms.global_contact.review_required",
  },
  // DEC-01/02: one per identity review (services/api crm_identity provider).
  { label: "Contact identity review", value: "crm.identity.review_required" },
  { label: "Issue report missing owner", value: "Issue report missing owner" },
  { label: "Issue report needs review", value: "Issue report needs review" },
  { label: "Issue report needs action", value: "Issue report needs action" },
  { label: "Failed job", value: "Failed job" },
  { label: "Stale job", value: "Stale job" },
  { label: "Automation failed", value: "Automation failed" },
  { label: "Automation throttled", value: "Automation throttled" },
  { label: "Manual alert", value: "Manual alert" },
  { label: "Provider disconnection", value: "accounting_connection_handoff" },
  { label: "Admin ops", value: "admin_ops_sop_request" },
  { label: "Support triage", value: "support_triage_quality" },
  // FHC funnel v1 (M6): system-emitted from services/api liveAlertsFhcFunnelEmitters.ts.
  { label: "Trial started", value: "Trial Started" },
  { label: "Trial not continued", value: "Trial Not Continued" },
  { label: "New subscription", value: "New Subscription" },
  { label: "FHC report failed", value: "Report generation failed" },
  // Payment recovery: services/api paymentRecoveryAlerts.ts.
  { label: "Renewal payment failed", value: "Renewal payment failed" },
  { label: "Account closes in 5 days", value: "Account closes in 5 days" },
  { label: "Recovery email not sent", value: "Recovery email not sent" },
].sort((left, right) =>
  left.label.localeCompare(right.label, "en", { sensitivity: "base" }),
);
